import React, {useEffect, useState} from 'react'
import { connect } from 'react-redux';
//import {SingleIbanCheck} from "../form-single-check/FormSingleCheck";
import FormIBAN from "../form-single-check/FormIBAN";
import {FileUploader} from "../../containers";


import { LogRequestGrid } from '../../containers/log-request-grid/LogRequestGrid';

const DashboardContainer = (props) => {

    const current = new Date();
    const from = new Date(new Date().setDate(current.getDate() - 5));
    const to = current;

    useEffect(() => {
    }, [])


    const nameValidation = (fieldName, fieldValue) => {
        if (fieldValue.trim() === "") {
          return `${fieldName} is required`;
        }
        // if (/[^a-zA-Z -]/.test(fieldValue)) {
        //   return "Invalid characters";
        // }
        if (fieldValue.trim().length < 27) {
          return `${fieldName} needs to be at least 27 characters`;
        }
        return null;
      };

      const cfValidation = (fieldName, fieldValue) => {
        if (fieldValue.trim() === "") {
       //   return `${fieldName} is required`;
         return null;
        }
        // if (/[^a-zA-Z -]/.test(fieldValue)) {
        //   return "Invalid characters";
        // }
        if (fieldValue.trim().length > 0 && fieldValue.trim().length < 11) {
          return `${fieldName} needs to be at least 11 characters`;
        }
        return null;
      };

      const pivaValidation = (fieldName, fieldValue) => {
        if (fieldValue.trim() === "") {
           //return `${fieldName} is required`;
           return null;
         }
        // if (/[^a-zA-Z -]/.test(fieldValue)) {
        //   return "Invalid characters";
        // }
        if (!fieldValue.trim().length === 11 && !fieldValue.substring(0, 2)==="IT" ) {
          return `${fieldName} needs to be of 11 characters`;
        }
        if (!fieldValue.trim().length === 13 && fieldValue.substring(0, 2)==="IT" ) {
          return `${fieldName} needs to be of 13 characters`;
        }
        return null;
      };
      
      const idValidation = (fieldName, fieldValue) => {
        // if (fieldValue.trim() === "") {
        //   return `${fieldName} is required`;
        // }
        // if (/[^a-zA-Z -]/.test(fieldValue)) {
        //   return "Invalid characters";
        // }
       // if (!fieldValue.trim().length === 11 ) {
       //   return `${fieldName} needs to be of 11 characters`;
       // }
        return null;
      };

      const validate = {
        iban: name => nameValidation("IBAN", name),
        cf: name => cfValidation("Fiscal Code", name),
        piva: name => pivaValidation("PIVA", name),
        id: name => idValidation("ID",name),
        esito: name => idValidation("ESITO",name),
        isValid: name => idValidation("IS VALID",name)
        // email: emailValidation,
        // age: ageValidation
      };
      
      const initialValues = {
        id: 1,  
        iban: '',
        piva: '',
        cf: '',
        esito: '',
        isValid:''

        
      };


   const [data, setDataGrid] = useState();
        
    return (<>
    
            <div className="dashboard-page">            

                <div className="row">

                    <div className="col-xxl-6 dashboard-title">
                        Welcome to IBAN Check
                        <br></br>
                    </div>

                </div>
                <div className="container border border-light">
                    <div className="row justify-content-md-center">
                        
                            {/* <div className="col-lg-7 dashboard-subtitle">
                                    Inserire IBAN e  Codice Fiscale / P.IVA da verificare:
                            </div> */}
                       </div>
                       <div className="row justify-content-md-center">
                        <div className="col-lg-7">
                            <FormIBAN validate={validate} initialValues={initialValues} />
                            
                            {/* <SingleIbanCheck /> */}

                         
                        </div>
                    </div>
                </div>
                <hr style={{ marginTop: "3.2em", marginBottom: "1.6em" }} />

               
                <div className="container border border-light">
                <h2 className="row justify-content-md-center">Import file Excel per validazione massiva:</h2>
                     <div className="row justify-content-md-center">
                        <div className="col-lg-11">
                            <FileUploader setDataGrid={setDataGrid} />
                        </div>
                    </div>
                    <div className="row justify-content-md-center">
                        <div className="col-lg-11" style={{ marginTop: "3.2em", marginBottom: "1.6em" }}>
                            <LogRequestGrid dataGrid={data} from={from} to={to} userPreFilter="Username" />
                        </div>
                    </div>
                </div>

            </div>

    </>);
}

const mapStateToProps = function(state) {
    return {
        
    }
  }

const mapDispatchToProps = dispatch => {
    return {
      
    }
  }
  
  export const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardContainer);